import React from 'react';
import TextArea from './TextArea';

const JsonSelect = ({title, current_data, update_data, note, rows}) => {
  console.log({current_data});
  return (
    <div className="space-y-2  ">
      {title && (
        <label className="block text-sm font-medium " htmlFor=" faq_url">
          {title}
        </label>
      )}
      {/* Json file input */}
      <input
        id="faq_url"
        className="form-input w-full"
        type="file"
        accept=".json"
        onChange={e => {
          // handle file input and get the json data
          const file = e.target.files[0];
          const reader = new FileReader();
          reader.onload = e => {
            update_data(JSON.parse(e.target.result));
          };
          reader.readAsText(file);
        }}
        onKeyPress={e => {
          e.stopPropagation();
        }}
      />{' '}
      {/* if value available show that as textarea */}
      {JSON.stringify(current_data) !== '{}' && (
        <TextArea
          current_data={JSON.stringify(current_data)}
          update_data={update_data}
          disabled={true}
        />
      )}
      {note && <p className="text-xs mt-2 italic">{note}</p>}
    </div>
  );
};

export default JsonSelect;
